import React, { useState } from "react";
import debounce from "lodash/debounce";
import styles from "../../../../../../styles/SearchPage.module.css";
import Icon from "../../../../../../layouts/common/icons/Icon";

export function LeadFormSearch({ handleSearchChange, placeholder, customStyle ,qtext}) {
    const debouncedHandleSearchChange = debounce((value) => {
        handleSearchChange(value);
    }, 300);

    const [qtextlocal,setQtext] = useState(qtext)

    const handleChange = (value)=>{
        setQtext(value);
        debouncedHandleSearchChange(value)
    }
    return (
        <div className={styles['locality-search-wrapper']} style={customStyle}>
            <input
                type="search"
                value={qtextlocal}
                onChange={(event) => handleChange(event.target.value)}
                placeholder={placeholder}
                style={{ border: "none", outline: "none" }}
            />
            <Icon iconName={"vm_blacksearch_icon"} style={{ fontSize: '19px', color: "black", marginRight: "8px" }} alt="search icon" />
        </div>
    );
}

export default LeadFormSearch;
